module.exports = __webpack_public_path__ + "static/media/alerts_1.72873204.svg";